import React, { useEffect, useState } from "react";
import "./Home.scss";
import { getAllAppAPI, activeAppAPI } from "../api/ClientApi";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useDispatch } from "react-redux";
import { handleLogoutRedux } from "../../redux/actions/userAction";
import { toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { Button, Confirm, useRecordContext, useDelete } from "react-admin";
const Home = (props) => {
  const [listApps, setListApps] = useState([]);
  const [checkedState, setCheckedState] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [message, setMessage] = useState("");
  const [position, setPosition] = useState(-1);
  const [reload, setReload] = useState(true);

  const history = useHistory();
  const dispatch = useDispatch();
  const handleDialogClose = () => {
    setShowAlert(false);
    setPosition(-1);
  };
  const handleConfirm = () => {
    setShowAlert(false);
    const { app_id, is_active } = listApps[position];
    setPosition(-1);
    console.log("AppID:", app_id, is_active);
    activeAppAPI({
      appId: app_id,
      isActive: is_active === 1 ? 0 : 1,
    }).then((response) => {
      let { errorCode, message } = response;
      if (errorCode === 0) {
        setReload(true);
        toast.success(message);
        history.push("/admin");
      } else if (errorCode === 401) {
        toast.error(message);
        dispatch(handleLogoutRedux());
      } else {
        toast.error(message);
      }
    });
  };
  const handleOnChange = (index) => {
    const { is_active } = listApps[index];
    setPosition(index);
    if (is_active === 1) {
      setMessage(`Xác nhận bỏ Active ứng dụng`);
      setShowAlert(true);
    }
    if (is_active === 0) {
      setMessage(`Xác nhận mở Active ứng dụng`);
      setShowAlert(true);
    }

    // console.log("updatedCheckedState:", JSON.stringify(updatedCheckedState));
  };

  useEffect(() => {
    if (reload) {
      getAllAppAPI().then((response) => {
        setReload(false);
        const { errorCode, message } = response;
        // console.log("response:", response);
        if (errorCode === 0) {
          setListApps(response.data);
          let updatedCheckedState = new Array(response.data.length).fill(false);
          updatedCheckedState = updatedCheckedState.map((item, index) =>
            response.data[index].is_active === 1 ? !item : item
          );

          setCheckedState(updatedCheckedState);
        } else if (errorCode === 401) {
          dispatch(handleLogoutRedux());
        } else {
          toast.error(message);
        }
      });
    }
  }, [reload]);

  return (
    <div className="home-container">
      <div className="mt-3 col-10  d-flex flex-column">
        <div className="div-btn d-flex flex-row-reverse">
          <button
            className="btn btn-primary create-btn"
            onClick={() => {
              history.push("/createApp");
            }}
          >
            Create New App
          </button>
        </div>
        <table className="table table-striped table-hover col-12 ">
          <thead>
            <tr>
              <th scope="col" className="col-1">
                #
              </th>
              <th scope="col" className="col-2">
                App ID
              </th>
              <th scope="col" className="col-2">
                App Name
              </th>
              <th scope="col" className="col-2">
                OS
              </th>
              <th scope="col" className="col-2">
                BundleID
              </th>
              <th scope="col" className="col-3">
                IconURL
              </th>
              <th scope="col" className="col-3">
                AppURL
              </th>
              <th scope="col" className="col-2">
                Active
              </th>
              <th scope="col" className="col-2">
                Edit
              </th>
            </tr>
          </thead>
          <tbody>
            {listApps.map((item, index) => {
              return (
                <tr key={index}>
                  <th className="table-light" scope="row">
                    {index + 1}
                  </th>
                  <td className="table-light"> {item.app_id}</td>
                  <td className="table-light">{item.app_name}</td>
                  <td className="table-light">{item.os}</td>
                  <td className="table-light">{item.bundle_id}</td>
                  <td className="table-light">
                    <div>{item.icon_url}</div>
                  </td>
                  <td className="table-light">
                    <div>{item.app_url}</div>
                  </td>
                  <td className="table-light">
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="darkmode"
                        id={`custom-checkbox-${index}`}
                        value={checkedState[index]}
                        checked={checkedState[index]}
                        onChange={(event) => {
                          handleOnChange(index);
                        }}
                      />
                    </div>
                  </td>
                  <td className="table-light">
                    <button className="edit-btn">
                      <img
                        src="./upload/ic_pen.png"
                        alt="edit btn"
                        className="edit-btn"
                        onClick={() => {
                          console.log("Click edit!");
                          history.push("/editApp", item);
                        }}
                      />
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <Confirm
        isOpen={showAlert}
        loading={false}
        title={``}
        content={message}
        confirm="Đồng ý"
        confirmColor="primary"
        cancel="Huỷ bỏ"
        onConfirm={handleConfirm}
        onClose={handleDialogClose}
      />
    </div>
  );
};
export default Home;
